import {
  isButtonEmpty,
  selectmenuAccessibilityCompliance,
  skipToAccessibleContent
} from '../utilities/helper';

function init() {
  isButtonEmpty();
  selectmenuAccessibilityCompliance();
  skipToAccessibleContent();
}

window.onload = function() {
  init();
};
